class CartDrawer extends DrawerComponent {
  constructor() {
    super();
    window.FoxKitSections = FoxTheme.utils.getSectionId(this);

    this.onCartRefreshListener = this.onCartRefresh.bind(this);
    this.getSectionToRenderListener = this.getSectionToRender.bind(this);
  }

  get requiresBodyAppended() {
    return false;
  }

  get sectionId() {
    return this.getAttribute("data-section-id");
  }

  connectedCallback() {
    super.connectedCallback();

    document.addEventListener(
      "cart:grouped-sections",
      this.getSectionToRenderListener
    );
    document.addEventListener("cart:refresh", this.onCartRefreshListener);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(
      "cart:grouped-sections",
      this.getSectionToRenderListener
    );
    document.removeEventListener("cart:refresh", this.onCartRefreshListener);
  }

  getSectionToRender(event) {
    event.detail.sections.push(FoxTheme.utils.getSectionId(this));
  }

  show(focusElement = null, animate = true) {
    super.show(focusElement, animate);

    if (this.open) {
      FoxTheme.a11y.trapFocus(this, this.focusElement);
    }
  }

  async onCartRefresh(event) {
    const cartId = `CartDrawer-${this.sectionId}`;

    const cartElement = document.getElementById(cartId);
    if (!cartElement) return;

    try {
      const response = await fetch(
        `${FoxTheme.routes.root_url}?section_id=${this.sectionId}`
      );
      const responseText = await response.text();

      const parser = new DOMParser();
      const parsedHTML = parser.parseFromString(responseText, "text/html");

      const newCartContent = parsedHTML.getElementById(cartId).innerHTML;
      cartElement.innerHTML = newCartContent;

      if (event.detail.open === true) {
        this.show();
      }
    } catch (error) {
      console.error("Error refreshing cart:", error);
    }
  }
}
customElements.define("cart-drawer", CartDrawer);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "change",
      FoxTheme.utils.debounce(this.onChange.bind(this), 300)
    );
    this.cartUpdateUnsubscriber = FoxTheme.pubsub.subscribe(
      FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate,
      this.onCartUpdate.bind(this)
    );

    this.cartItemProducts = this.querySelectorAll(".cart-item__product");
    this.cartItemQuantitys = this.querySelectorAll(".cart-item__quantity");

    const loadTemplateContent = (elements, parentSelector) => {
      elements.forEach((element) => {
        const template = element.querySelector("template");
        const templateContent =
          template && document.importNode(template.content, true);
        const parent = element.querySelector(parentSelector);

        if (parent && template && !parent.querySelector(".template-content")) {
          const contentWrapper = document.createElement("div");
          contentWrapper.classList.add("template-content", "w-full");
          contentWrapper.appendChild(templateContent);
          parent.appendChild(contentWrapper);
        }
      });
    };

    const removeTemplateContent = (elements, parentSelector) => {
      elements.forEach((element) => {
        const parent = element.querySelector(parentSelector);
        const templateContent = parent?.querySelector(".template-content");

        if (templateContent) {
          parent.removeChild(templateContent);
        }
      });
    };

    const handleTabletMatch = () => {
      loadTemplateContent(this.cartItemProducts, ".cart-item__product--info");
      removeTemplateContent(
        this.cartItemQuantitys,
        ".cart-item__quantity-wrapper"
      );
    };

    const handleTabletUnmatch = () => {
      removeTemplateContent(this.cartItemProducts, ".cart-item__product--info");
      loadTemplateContent(
        this.cartItemQuantitys,
        ".cart-item__quantity-wrapper"
      );
    };

    const mqlTablet = window.matchMedia(FoxTheme.config.mediaQueryTablet);
    FoxTheme.config.mqlTablet = mqlTablet.matches;

    if (FoxTheme.config.mqlTablet) {
      handleTabletMatch();
    } else {
      handleTabletUnmatch();
    }

    mqlTablet.onchange = (event) => {
      if (event.matches) {
        handleTabletMatch();
      } else {
        FoxTheme.config.mqlTablet = false;
        handleTabletUnmatch();
      }
    };

    window.FoxKitSections = FoxTheme.utils.getSectionId(this);
  }

  cartUpdateUnsubscriber = undefined;

  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
  }

  onChange(event) {
    this.validateQuantity(event);
  }

  setValidity(target, message) {
    target.setCustomValidity(message);
    target.reportValidity();
    target.value = target.defaultValue;
    target.select();
  }

  validateQuantity(event) {
    const target = event.target;
    const inputValue = parseInt(target.value);
    const index = target.getAttribute("data-index");
    let message = "";

    if (inputValue < parseInt(target.getAttribute("data-min"))) {
      message = FoxTheme.quickOrderListStrings.min_error.replace(
        "[min]",
        target.getAttribute("data-min")
      );
    } else if (inputValue > parseInt(target.max)) {
      message = FoxTheme.quickOrderListStrings.max_error.replace(
        "[max]",
        target.max
      );
    } else if (inputValue % parseInt(target.step) !== 0) {
      message = FoxTheme.quickOrderListStrings.step_error.replace(
        "[step]",
        target.step
      );
    }

    if (message) {
      this.setValidity(target, message);
    } else {
      target.setCustomValidity("");
      target.reportValidity();
      this.updateQuantity(
        index,
        inputValue,
        document.activeElement.getAttribute("name"),
        target
      );
    }
  }

  onCartUpdate(event) {
    if (event.cart.errors) {
      this.onCartError(event.cart.errors, event.target);
      return;
    }

    const sectionId = FoxTheme.utils.getSectionId(this);
    const sectionToRender = new DOMParser().parseFromString(
      event.cart.sections[sectionId],
      "text/html"
    );

    const cartDrawer = document.querySelector(`#CartDrawer-${sectionId}`);
    const cartDrawerBody = document.querySelector(
      `#CartDrawerBody-${sectionId}`
    );
    const cartDrawerFooter = document.querySelector(
      `#CartDrawerFooter-${sectionId}`
    );
    const cartDrawerEmpty = document.querySelector(
      `#CartDrawerEmpty-${sectionId}`
    );
    if (cartDrawer) {
      // const updatedElement = sectionToRender.querySelector(`#CartDrawer-${sectionId}`);
      // if (updatedElement) {
      //   cartDrawer.innerHTML = updatedElement.innerHTML;
      // }
      const cartDrawerBodyUpdate = sectionToRender.querySelector(
        `#CartDrawerBody-${sectionId}`
      );
      const cartDrawerFooterUpdate = sectionToRender.querySelector(
        `#CartDrawerFooter-${sectionId}`
      );
      const cartDrawerEmptyUpdate = sectionToRender.querySelector(
        `#CartDrawerEmpty-${sectionId}`
      );

      if (cartDrawerBodyUpdate) {
        cartDrawerBody.innerHTML = cartDrawerBodyUpdate.innerHTML;
      }
      if (cartDrawerFooterUpdate) {
        cartDrawerFooter.innerHTML = cartDrawerFooterUpdate.innerHTML;
      }

      if (cartDrawerEmptyUpdate) {
        cartDrawerEmpty.innerHTML = cartDrawerEmptyUpdate.innerHTML;
      }

      if (event.cart.item_count > 0) {
        cartDrawerBody.classList.remove("hidden");
        cartDrawerFooter.classList.remove("hidden");
        cartDrawerEmpty.classList.add("hidden");
      } else {
        cartDrawerBody.classList.add("hidden");
        cartDrawerFooter.classList.add("hidden");
        cartDrawerEmpty.classList.remove("hidden");
      }
    }

    const mainCart = document.querySelector(`#MainCart-${sectionId}`);
    if (mainCart) {
      const updatedElement = sectionToRender.querySelector(
        `#MainCart-${sectionId}`
      );
      if (updatedElement) {
        mainCart.innerHTML = updatedElement.innerHTML;
      } else {
        mainCart.closest(".cart").classList.add("is-empty");
        mainCart.remove();
      }
    }

    const lineItem =
      document.getElementById(`CartItem-${event.line}`) ||
      document.getElementById(`CartDrawer-Item-${event.line}`);

    if (lineItem && lineItem.querySelector(`[name="${event.name}"]`)) {
      FoxTheme.a11y.trapFocus(
        mainCart || cartDrawer,
        lineItem.querySelector(`[name="${event.name}"]`)
      );
    } else if (event.cart.item_count === 0) {
      cartDrawer
        ? FoxTheme.a11y.trapFocus(cartDrawer, cartDrawer.querySelector("a"))
        : FoxTheme.a11y.trapFocus(
            document.querySelector(".cart__empty"),
            document.querySelector("a")
          );
    } else {
      cartDrawer
        ? FoxTheme.a11y.trapFocus(
            cartDrawer,
            cartDrawer.querySelector(".cart-item__title")
          )
        : FoxTheme.a11y.trapFocus(
            mainCart,
            mainCart.querySelector(".cart-item__title")
          );
    }

    document.dispatchEvent(
      new CustomEvent("cart:updated", {
        detail: {
          cart: event.cart,
        },
      })
    );
  }

  onCartError(errors, target) {
    if (target) {
      this.updateQuantity(
        target.getAttribute("data-index"),
        target.defaultValue,
        document.activeElement.getAttribute("name"),
        target
      );
    } else {
      window.location.href = FoxTheme.routes.cart_url;
    }

    alert(errors);
  }

  updateQuantity(line, quantity, name, target, sectionsToBundleDefault) {
    this.showLoader(line);

    let sectionsToBundle = sectionsToBundleDefault ?? [];
    document.documentElement.dispatchEvent(
      new CustomEvent("cart:grouped-sections", {
        bubbles: true,
        detail: { sections: sectionsToBundle },
      })
    );

    const body = JSON.stringify({
      line,
      quantity,
      sections: sectionsToBundle,
    });

    fetch(`${FoxTheme.routes.cart_change_url}`, {
      ...FoxTheme.utils.fetchConfig(),
      ...{ body },
    })
      .then((response) => response.json())
      .then((parsedState) => {
        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
          sources: "cart-items",
          cart: parsedState,
          target,
          line,
          name,
        });
      })
      .catch((error) => {
        console.log(error);
      });
  }

  showLoader(line) {
    const sectionId = FoxTheme.utils.getSectionId(this);
    const loaders = document.querySelectorAll(`#Loader-${sectionId}-${line}`);
    if (loaders) {
      loaders.forEach((loader) => {
        loader.classList.add("btn--loading");
      });
    }
  }
}

customElements.define("cart-items", CartItems);

class CartRemoveItem extends HTMLAnchorElement {
  constructor() {
    super();

    this.removeCartItemWithDeleteDataAttr();
    this.addEventListener("click", (event) => {
      event.preventDefault();

      const cartItems = this.closest("cart-items");
      cartItems.updateQuantity(this.dataset.index, 0);
    });
  }

  removeCartItemWithDeleteDataAttr() {
    const lineItemsToDelete = document.querySelectorAll(
      "[data-auto-cart-delete]"
    );

    for (const lineItem of lineItemsToDelete) {
      const removeButton = lineItem.querySelector('[is="cart-remove-item"]');
      if (!removeButton) return;

      const cartItems = removeButton.closest("cart-items");
      const index = removeButton.dataset.index;

      // Properly collect sections to re-render
      const sectionsToBundle = [];
      sectionsToBundle.push(FoxTheme.utils.getSectionId(cartItems));

      cartItems.updateQuantity(index, 0, null, removeButton, sectionsToBundle); // `name` is optional, target is needed
    }
  }
}
customElements.define("cart-remove-item", CartRemoveItem, { extends: "a" });
class CartNote extends HTMLElement {
  constructor() {
    super();

    this.addEventListener(
      "change",
      FoxTheme.utils.debounce(this.onChange.bind(this), 300)
    );

    if (this.button && this.cartNoteDetailsSummary) {
      this.button.addEventListener("click", () => {
        this.cartNoteDetailsSummary.close();
      });
    }
  }

  get cartNoteDetailsSummary() {
    return this.closest('[is="accordion-details"]');
  }

  get button() {
    return this.querySelector('[type="button"]');
  }

  onChange(event) {
    const body = JSON.stringify({ note: event.target.value });
    fetch(`${FoxTheme.routes.cart_update_url}`, {
      ...FoxTheme.utils.fetchConfig(),
      ...{ body },
    });
  }
}
customElements.define("cart-note", CartNote);

class CalculateShipping extends ModalComponent {
  constructor() {
    super();
    this.countryProvince = this.querySelector("country-province");
    this.isCountrySetup = false;
  }
  static get observedAttributes() {
    return [...super.observedAttributes, "data-show"];
  }
  show() {
    super.show();
    this.setAttribute("data-show", true);
  }

  hide() {
    super.hide();
    this.setAttribute("data-show", false);
  }

  attributeChangedCallback(name, oldValue, newValue) {
    super.attributeChangedCallback(name, oldValue, newValue);
    if (
      name === "data-show" &&
      newValue === "true" &&
      !this.isCountrySetup &&
      this.countryProvince
    ) {
      const template = this.countryProvince.querySelector("template");
      const templateContent = document.importNode(template.content, true);
      this.countryProvince.countryElement.appendChild(templateContent);
      this.countryProvince.init();
      this.isCountrySetup = true;
    }
  }
}
customElements.define("calculate-shipping", CalculateShipping);
class CountryProvinceForm extends HTMLElement {
  constructor() {
    super();
    this.provinceElement = this.querySelector('[name="address[province]"]');
    this.countryElement = this.querySelector('[name="address[country]"]');
    this.template = this.dataset.template;
    this.countryElement.addEventListener(
      "change",
      this.handleCountryChange.bind(this)
    );
    if (this.template && this.template === "cart") {
      this.init();
    }
  }

  init() {
    if (this.getAttribute("country") !== "") {
      this.countryElement.selectedIndex = Math.max(
        0,
        Array.from(this.countryElement.options).findIndex(
          (option) => option.textContent === this.dataset.country
        )
      );
      this.countryElement.dispatchEvent(new Event("change"));
    } else {
      this.handleCountryChange();
    }
  }

  handleCountryChange() {
    const option =
        this.countryElement.options[this.countryElement.selectedIndex],
      provinces = JSON.parse(option.dataset.provinces);

    this.provinceElement.closest(".form-field").hidden = provinces.length === 0;

    if (provinces.length === 0) {
      return;
    }

    this.provinceElement.innerHTML = "";

    provinces.forEach((data) => {
      const selected = data[1] === this.dataset.province;
      this.provinceElement.options.add(
        new Option(data[1], data[0], selected, selected)
      );
    });
  }
}
customElements.define("country-province", CountryProvinceForm);

class ShippingCalculator extends HTMLFormElement {
  constructor() {
    super();

    this.submitButton = this.querySelector('[type="submit"]');
    this.resultsElement = this.lastElementChild;

    this.submitButton.addEventListener(
      "click",
      this.handleFormSubmit.bind(this)
    );
  }

  handleFormSubmit(event) {
    event.preventDefault();

    const zip = this.querySelector('[name="address[zip]"]').value,
      country = this.querySelector('[name="address[country]"]').value,
      province = this.querySelector('[name="address[province]"]').value;

    this.submitButton.classList.add("btn--loading");

    const body = JSON.stringify({
      shipping_address: { zip, country, province },
    });
    let sectionUrl = `${FoxTheme.routes.cart_url}/shipping_rates.json`;

    sectionUrl = sectionUrl.replace("//", "/");

    fetch(sectionUrl, {
      ...FoxTheme.utils.fetchConfig("javascript"),
      ...{ body },
    })
      .then((response) => response.json())
      .then((parsedState) => {
        if (parsedState.shipping_rates) {
          this.formatShippingRates(parsedState.shipping_rates);
        } else {
          this.formatError(parsedState);
        }
      })
      .catch((e) => {
        console.error(e);
      })
      .finally(() => {
        this.resultsElement.hidden = false;
        this.submitButton.classList.remove("btn--loading");
      });
  }

  formatError(errors) {
    const shippingRatesList = Object.keys(errors).map((errorKey) => {
      return `<li>${errors[errorKey]}</li>`;
    });
    this.resultsElement.innerHTML = `
      <div class="alert alert--error blocks-radius grid gap-2">
        <p class="font-body-bolder m-0">${
          FoxTheme.shippingCalculatorStrings.error
        }</p>
        <ul class="list-disc grid gap-1 text-sm" role="list">${shippingRatesList.join(
          ""
        )}</ul>
      </div>
    `;
  }

  formatShippingRates(shippingRates) {
    const shippingRatesList = shippingRates.map(
      ({ presentment_name, currency, price }) => {
        return `<li>${presentment_name}: ${currency} ${price}</li>`;
      }
    );
    this.resultsElement.innerHTML = `
      <div class="alert blocks-radius alert--${
        shippingRates.length === 0 ? "error" : "success"
      } grid gap-2 leading-tight">
        <p class="font-body-bolder m-0">${
          shippingRates.length === 0
            ? FoxTheme.shippingCalculatorStrings.notFound
            : shippingRates.length === 1
            ? FoxTheme.shippingCalculatorStrings.oneResult
            : FoxTheme.shippingCalculatorStrings.multipleResults
        }</p>
        ${
          shippingRatesList === ""
            ? ""
            : `<ul class="list-disc grid gap-1 text-sm" role="list">${shippingRatesList.join(
                ""
              )}</ul>`
        }
      </div>
    `;
  }
}
customElements.define("shipping-calculator", ShippingCalculator, {
  extends: "form",
});

class CartDrawerProductsRecommendation extends HTMLElement {
  constructor() {
    super();
    if ("requestIdleCallback" in window) {
      requestIdleCallback(this.init.bind(this), { timeout: 1500 });
    } else {
      const userAgent = navigator.userAgent;
      const isSafari =
        userAgent.includes("Safari") && !userAgent.includes("Chrome");
      if (isSafari) {
        this.init();
      } else {
        FoxTheme.Motion.inView(this, this.init.bind(this), {
          margin: "600px 0px 600px 0px",
        });
      }
    }
  }

  get slideContainer() {
    return this.querySelector(".swiper");
  }

  get sliderPagination() {
    return this.querySelector(".swiper-pagination");
  }

  get sliderNext() {
    return this.querySelector(".swiper-button-next");
  }

  get sliderPrev() {
    return this.querySelector(".swiper-button-prev");
  }

  init() {
    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((responseText) => {
        const sectionInnerHTML = new DOMParser()
          .parseFromString(responseText, "text/html")
          .querySelector(".shopify-section");

        if (sectionInnerHTML === null) return;

        const recommendations = sectionInnerHTML.querySelector(
          "cart-drawer-products-recommendation"
        );
        if (recommendations && recommendations.innerHTML.trim().length) {
          const productCount =
            recommendations.querySelectorAll(".product-card");
          this.innerHTML = recommendations.innerHTML;
          this.initCarousel();
          if (productCount.length > 0) this.classList.remove("hidden");
          this.dispatchEvent(new CustomEvent("recommendations:loaded"));
        } else {
          this.closest(".shopify-section").remove();
          this.classList.add("hidden");
          this.dispatchEvent(new CustomEvent("is-empty"));
        }
      })
      .catch((e) => {
        console.error(e);
      });
  }

  initCarousel() {
    this.carousel = new FoxTheme.Carousel(this.slideContainer, {
      slidesPerView: 1,
      spaceBetween: 10,
      loop: false,
      pagination: {
        el: this.sliderPagination,
        type: "fraction",
      },
      navigation: {
        nextEl: this.sliderNext,
        prevEl: this.sliderPrev,
      },
    });

    this.carousel && this.carousel.init();
  }
}

customElements.define(
  "cart-drawer-products-recommendation",
  CartDrawerProductsRecommendation
);

class MainCart extends HTMLElement {
  constructor() {
    super();

    document.addEventListener(
      "cart:grouped-sections",
      this.getSectionToRender.bind(this)
    );
  }

  getSectionToRender(event) {
    event.detail.sections.push(FoxTheme.utils.getSectionId(this));
  }
}
customElements.define("main-cart", MainCart);

class FreeShippingGoal extends HTMLElement {
  constructor() {
    super();

    this.selectors = {
      defaultLabel: ".free-shipping-goal__label--default",
      successLabel: ".free-shipping-goal__label--success",
      progressBarContainer: ".progress-bar-container",
      shippingIconTemplate: "#fs-template-icon-shipping",
      giftIconTemplate: "#fs-template-icon-gift",
    };

    this.progressBarContainer = this.querySelector(
      this.selectors.progressBarContainer
    );
    this.defaultLabel = this.querySelector(this.selectors.defaultLabel);
    this.successLabel = this.querySelector(this.selectors.successLabel);
    this.moneyFormat = window.FoxTheme?.settings?.moneyFormat || "${{amount}}";
    this.currencyRate = Number(window.Shopify?.currency?.rate || 1);

    const shippingThreshold = Number(this.dataset.shippingThresholdCents) || 0;
    const giftOneThreshold = Number(this.dataset.giftOneThresholdCents) || 0;
    const giftTwoThreshold = Number(this.dataset.giftTwoThresholdCents) || 0;
    this.goals = [];

    if (shippingThreshold > 0) {
      this.goals.push({
        type: "shipping",
        amount: shippingThreshold,
        name:
          this.dataset.freeShippingName ||
          window.FoxTheme?.strings?.freeShipping ||
          "Doprava zdarma",
      });
    }

    if (giftOneThreshold > 0) {
      this.goals.push({
        type: "gift",
        amount: giftOneThreshold,
        name:
          this.dataset.giftOneName ||
          window.FoxTheme?.strings?.freeGift ||
          "Dárek zdarma",
      });
    }

    if (giftTwoThreshold > 0) {
      this.goals.push({
        type: "gift",
        amount: giftTwoThreshold,
        name:
          this.dataset.giftTwoName ||
          window.FoxTheme?.strings?.anotherFreeGift ||
          "Dárek zdarma",
      });
    }

    this.goals.sort((a, b) => a.amount - b.amount);
    this.highestGoalAmount =
      this.goals.length > 0 ? this.goals[this.goals.length - 1].amount : 0;

    this.setupSegmentedBar();
  }

  connectedCallback() {
    this.updateShippingGoal(Number(this.dataset.cartTotalCents) || 0);

    document.addEventListener("cart:updated", (event) => {
      const cartTotalCents =
        event.detail?.cart?.items_subtotal_price ??
        event.detail?.cart?.total_price ??
        0;
      this.updateShippingGoal(cartTotalCents);
    });

    document.addEventListener("currency:update", () => {
      this.currencyRate = Number(window.Shopify?.currency?.rate || 1);
      this.updateShippingGoal(Number(this.dataset.cartTotalCents) || 0);
    });
  }

  setupSegmentedBar() {
    this.progressBarContainer.innerHTML = "";
    this.progressBarContainer.style.display = "flex";

    if (this.highestGoalAmount <= 0 || this.goals.length === 0) return;

    const shippingIconTemplate = document.getElementById(
      "fs-template-icon-shipping"
    );
    const giftIconTemplate = document.getElementById("fs-template-icon-gift");

    let prevGoalAmount = 0;

    this.goals.forEach((goal) => {
      const segmentEndAmount = goal.amount;
      const segmentRange = segmentEndAmount - prevGoalAmount;
      const segmentWidthPercent = (segmentRange / this.highestGoalAmount) * 100;

      if (segmentWidthPercent <= 0) {
        prevGoalAmount = segmentEndAmount;
        return;
      }

      const segmentContainer = document.createElement("div");
      segmentContainer.classList.add("segment-container");
      segmentContainer.dataset.segmentGoalAmount = segmentEndAmount;
      segmentContainer.style.flexBasis = `${segmentWidthPercent}%`;
      segmentContainer.style.webkitFlexBasis = `${segmentWidthPercent}%`;

      const segmentFill = document.createElement("div");
      segmentFill.classList.add("segment-fill");
      segmentFill.style.width = "0%";
      segmentContainer.appendChild(segmentFill);

      this.progressBarContainer.appendChild(segmentContainer);

      const markerPercent = (segmentEndAmount / this.highestGoalAmount) * 100;

      const visualWrapper = document.createElement("div");
      visualWrapper.classList.add("threshold-visual-wrapper");
      visualWrapper.dataset.thresholdAmount = segmentEndAmount;

      let iconTemplateToClone = null;
      if (goal.type === "shipping" && shippingIconTemplate) {
        iconTemplateToClone = shippingIconTemplate;
      } else if (goal.type === "gift" && giftIconTemplate) {
        iconTemplateToClone = giftIconTemplate;
      }

      if (iconTemplateToClone) {
        const iconElement = iconTemplateToClone.cloneNode(true);
        iconElement.removeAttribute("id");
        visualWrapper.appendChild(iconElement);
      }

      const textElement = document.createElement("span");
      textElement.classList.add("threshold-text");
      textElement.textContent = goal.name;
      visualWrapper.appendChild(textElement);

      visualWrapper.setAttribute(
        "title",
        `${goal.name} at ${FoxTheme.Currency.formatMoney(
          segmentEndAmount,
          this.moneyFormat
        )}`
      );

      this.progressBarContainer.appendChild(visualWrapper);

      prevGoalAmount = segmentEndAmount;
    });
  }

  updateShippingGoal(cartTotalCents) {
    const currentTotalCents = cartTotalCents;

    if (currentTotalCents > 0 && this.highestGoalAmount > 0) {
      this.classList.remove("hidden");
    } else {
      this.classList.add("hidden");
      this.defaultLabel.style.display = "none";
      this.successLabel.style.display = "none";
      return;
    }

    let nextGoal = null;
    for (const goal of this.goals) {
      if (currentTotalCents < goal.amount) {
        nextGoal = goal;
        break;
      }
    }

    if (nextGoal) {
      const remainingCents = nextGoal.amount - currentTotalCents;
      const remainingFormatted = FoxTheme.Currency.formatMoney(
        remainingCents,
        this.moneyFormat
      );
      let message = "";

      if (nextGoal.type === "gift") {
        message = (
          window.FoxTheme?.strings?.remaining_gift_html ||
          "Nakúpte ešte za <strong>{{ remaining_amount }}</strong> a získajte <strong>{{ gift_name }}</strong>!"
        )
          .replace("{{ remaining_amount }}", remainingFormatted)
          .replace("{{ gift_name }}", nextGoal.name);
      } else {
        message = (
          window.FoxTheme?.strings?.remaining_html ||
          "Nakúpte ešte za <strong>{{ remaining_amount }}</strong> a získajte <strong>{{ goal_name }}</strong>!"
        )
          .replace("{{ remaining_amount }}", remainingFormatted)
          .replace("{{ goal_name }}", nextGoal.name);
      }

      this.defaultLabel.innerHTML = message;
      this.defaultLabel.style.display = "";
      this.successLabel.style.display = "none";
      this.classList.remove("free-shipping-goal--done");
    } else {
      this.defaultLabel.style.display = "none";
      this.successLabel.innerHTML =
        window.FoxTheme?.strings?.congratulations_html ||
        "Získali jste všechny výhody!";
      this.successLabel.style.display = "";
      this.classList.add("free-shipping-goal--done");
    }

    let prevGoalAmount = 0;
    this.goals.forEach((goal) => {
      const segmentEndAmount = goal.amount;
      const segmentContainer = this.progressBarContainer.querySelector(
        `.segment-container[data-segment-goal-amount="${segmentEndAmount}"]`
      );

      if (segmentContainer) {
        const segmentFill = segmentContainer.querySelector(".segment-fill");
        if (segmentFill) {
          const segmentRange = segmentEndAmount - prevGoalAmount;
          const progressInSegment = Math.max(
            0,
            currentTotalCents - prevGoalAmount
          );
          let segmentFillPercent = 0;

          if (segmentRange > 0) {
            segmentFillPercent = Math.min(
              100,
              (progressInSegment / segmentRange) * 100
            );
          } else {
            segmentFillPercent =
              currentTotalCents >= segmentEndAmount ? 100 : 0;
          }

          segmentFill.style.width = `${segmentFillPercent}%`;
        }
      }

      prevGoalAmount = segmentEndAmount;
    });

    this.goals.forEach((goal) => {
      const visualWrapper = this.progressBarContainer.querySelector(
        `.threshold-visual-wrapper[data-threshold-amount="${goal.amount}"]`
      );

      if (visualWrapper) {
        if (currentTotalCents >= goal.amount) {
          visualWrapper.classList.add("threshold--achieved");
        } else {
          visualWrapper.classList.remove("threshold--achieved");
        }

        if (this.querySelector(".progress-bar-gift-success")) {
          if (goal.type == "gift" && currentTotalCents >= goal.amount) {
            this.querySelector(".progress-bar-gift-success").style.display =
              "block";
          }
          if (goal.type == "gift" && currentTotalCents < goal.amount) {
            this.querySelector(".progress-bar-gift-success").style.display =
              "none";
          }
        }
      }
    });
  }
}

if (!customElements.get("free-shipping-goal")) {
  customElements.define("free-shipping-goal", FreeShippingGoal);
}

window.FoxKitAddToCart = async (payload) => {
  if (!payload?.properties?.["_FoxKit offer"]) return;

  const cartJson = await (
    await fetch(`${FoxTheme.routes.cart_url}`, {
      ...FoxTheme.utils.fetchConfig(),
    })
  ).json();
  cartJson["sections"] = payload["sections"];
  FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate, {
    cart: cartJson,
  });

  document.dispatchEvent(
    new CustomEvent("product-ajax:added", {
      detail: {
        product: payload,
      },
    })
  );
};
